import React, { useState } from 'react';
import { DatePicker, Form } from 'antd';
import { Moment } from 'moment';

import { TIME_FORMAT } from '../../../utils/date';

type DateInputProps = {
  name: string;
  label: string;
  value?: Moment;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: Moment | null) => void;
};

export function TimeInput(props: DateInputProps) {
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const handleChange = (value: Moment | null) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };

  return (
    <>
      <Form.Item name={props.name} label={props.label} rules={[{ required: props.required, message: `${props.label} is required` }]}>
        <DatePicker.TimePicker
          format={TIME_FORMAT}
          inputReadOnly
          open={isPickerOpen}
          onBlur={() => setIsPickerOpen(false)}
          onOpenChange={(isOpen) => setIsPickerOpen(isOpen)}
          placeholder="Select time"
          use12Hours
          minuteStep={15}
          style={{ width: '100%' }}
          value={props.value}
          onChange={handleChange}
          disabled={props.disabled}
        />
      </Form.Item>
    </>
  );
}
